import React from 'react';
import { SmartContext } from './SmartContext';
import DebugBarControl from '../SimpleControls/DebugBarControl';
import FactLoader from '../SimpleControls/FactLoader';

interface SmartContextPageProps {
    state: any;
    dispatch: any;
    children: React.ReactNode;
    showDebug?: boolean;
    /** @deprecated no longer displayed — FactLoader has no status text. Kept optional so existing call sites don't need to change. */
    message?: string;
}

/**
 * Drop-in wrapper for every SmartContext page.
 * Shows the branded FactLoader overlay while isDataLoading is true,
 * then renders children once data is ready.
 *
 * Usage:
 *   <SmartContextPage state={state} dispatch={dispatch}>
 *     <Layout />
 *   </SmartContextPage>
 */
const SmartContextPage = ({ state, dispatch, children, showDebug = true }: SmartContextPageProps) => (
    <SmartContext.Provider value={{ state, dispatch }}>
        {showDebug && <DebugBarControl />}
        <FactLoader show={state.flags.isDataLoading} />
        {!state.flags.isDataLoading && children}
    </SmartContext.Provider>
);

export default SmartContextPage;
